<template>
  <component
    v-if="schema"
    :is="layouts.editing && !!schema.build ? schema.build : schema.view"
    :options="options"
  />
</template>

<script setup lang="ts">
import copy from "@virgodev/bazaar/functions/copy";
import { computed } from "vue";
import { useLayoutStore } from "../stores/layouts";
import type { LayoutCard } from "../utils/layout";

const props = defineProps<{
  layout: LayoutCard;
}>();

const layouts = useLayoutStore();

const schema = computed(() => {
  return layouts.manifest[props.layout.type];
});

const options = computed(() => {
  const retval = copy(props.layout.options);
  if (schema.value && schema.value.defaults) {
    for (const key in schema.value.defaults) {
      if (retval[key] === undefined) {
        retval[key] = schema.value.defaults[key];
      }
    }
  }
  return retval;
});
</script>
